import {mergeDeepRight} from 'ramda'
import {urlParams} from 'utils/urlParams'

import {buildUrl} from '@vio/core/src/utils/url'

type GetNewLocationUrlPropsType = {
  url?: string
  search?: Record<string, unknown>
  replaceSearchParams?: boolean
  replace?: boolean
}

const getNewLocationUrl = ({
  url = '',
  search = {},
  replaceSearchParams = false
}: GetNewLocationUrlPropsType = {}) => {
  const params = urlParams()
  delete params.profile
  delete params.overlay
  const objectToStringify = replaceSearchParams
    ? search
    : mergeDeepRight(params, search)

  const newUrl = buildUrl(url, objectToStringify, {arrayFormat: 'indices'})

  return newUrl
}

export default getNewLocationUrl
